document.addEventListener("DOMContentLoaded",function(){

    /**
     * Open whakapapa table for entered rows
     */
    let whakapapaIndex = 0;
    for(var rowIdx=1; rowIdx<12; rowIdx++){
        var row = document.getElementById('aw_'+rowIdx);
        var rowAffiliateId = document.getElementById("affiliate_id_"+rowIdx);

        if(rowAffiliateId) {
            if (rowAffiliateId.value) {
                row.style.display = "";
                whakapapaIndex = rowIdx;
            } else {
                row.style.display = "none";
            }
        }
    }

    /**
     * Open tamariki table for entered rows
     */
    let tamarikiIndex = 0;
    for(var rowIdx=1; rowIdx<16; rowIdx++){
        var tamarikiDiv = document.getElementById('tamariki_'+rowIdx);
        var tamarikiName = document.getElementById('tamariki_name_'+rowIdx);

        if(tamarikiName && tamarikiName.value){
            tamarikiDiv.classList.remove('is-hidden');
        }
    }


    /**
     * Get Mare list for selected Affiliate
     */
    let primaryAffiliate = document.getElementById('primary_affiliate_id');
    if(primaryAffiliate){
        primaryAffiliate.addEventListener('change',function(e){

            let uri = `/api/public/maraeList?affiliate=`+this.value;

            fetch(uri, {
                method: "GET",              //- *GET, POST, PUT, DELETE, etc.
                mode: "cors",               //- no-cors, cors, *same-origin
                cache: "no-cache",          //- *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", //- include, same-origin, *omit
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                redirect: "follow",         //- manual, *follow, error
                referrer: "no-referrer",    //- no-referrer, *client
            })
            .then(function(response) {
                // console.log(JSON.stringify(response));
                return response.json();
            })
            .then(function(jsn) {

                let maraeOptions = document.getElementById('marae_id').options;
                maraeOptions.length = 0;

                maraeOptions.add(new Option("Select Marae", -1, true));
                maraeOptions.add(new Option("No Marae", 0, true));

                Object.entries(jsn.maraes).map(([id,name]) => {
                    maraeOptions.add(new Option(name, id, false));
                });
            });
        });
    }

    let additionalAffiliate = document.getElementById('additional_affiliate_id');
    if(additionalAffiliate){
        additionalAffiliate.addEventListener('change',function(e){

            let uri = `/api/public/maraeList?affiliate=`+this.value;

            fetch(uri, {
                method: "GET",              //- *GET, POST, PUT, DELETE, etc.
                mode: "cors",               //- no-cors, cors, *same-origin
                cache: "no-cache",          //- *default, no-cache, reload, force-cache, only-if-cached
                credentials: "same-origin", //- include, same-origin, *omit
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                redirect: "follow",         //- manual, *follow, error
                referrer: "no-referrer",    //- no-referrer, *client
            })
            .then(function(response) {
                // console.log(JSON.stringify(response));
                return response.json();
            })
            .then(function(jsn) {

                let maraeOptions = document.getElementById('additional_marae_id').options;
                maraeOptions.length = 0;

                maraeOptions.add(new Option("Select Marae", -1, true));
                maraeOptions.add(new Option("No Marae", 0, true));

                Object.entries(jsn.maraes).map(([id,name]) => {
                    maraeOptions.add(new Option(name, id, false));
                });
            });
        });
    }

    let fieldLastname = document.getElementById('last_name');
    let fieldFirstname = document.getElementById('first_name');
    let fieldApplicant = document.getElementById('applicant_name');

    if(fieldApplicant){
        fieldApplicant.addEventListener('focus',function(e){
           this.value = fieldFirstname.value + " " + fieldLastname.value;
        });
    }

    let btnWhakapapa = document.getElementById('btnWhakapapa'),
        btnWhakapapaSubmit = document.getElementById('btnWhakapapaSubmit'),
        whakapapaModal = document.getElementById('whakapapaModal'),
        html = document.querySelector('html');

    if(btnWhakapapa) {
        btnWhakapapa.addEventListener('click', function (e) {

            if(whakapapaModal) {
                whakapapaModal.classList.toggle('is-active');
                html.classList.add('is-clipped');

                let closers = whakapapaModal.querySelectorAll('.close-modal,.modal-background');

                // let idx;
                for (var idx = 0; idx < closers.length; idx++) {
                    closers[idx].addEventListener('click', function(e){
                        e.preventDefault();
                        whakapapaModal.classList.remove('is-active');
                        html.classList.remove('is-clipped');
                    });
                }

                document.getElementById("additional_affiliate_id").focus();
            }
        });
    }
    if(btnWhakapapaSubmit){


        btnWhakapapaSubmit.addEventListener('click', function (e) {

            /**
             * Validate the whakapapa table
             * @type {HTMLElement | null}
             */

            var affiliates = document.getElementById('additional_affiliate_id');
            if(affiliates.selectedIndex<1){
                if(affiliates.closest('p.help')) {
                    affiliates.closest('p.help').html("Please select an Affiliate");
                }
                alert("Please select an Affiliate");
                return;
            }

            var maraes = document.getElementById('additional_marae_id');
            if(maraes.selectedIndex<1){
                alert("Please select an Marae");
                return;
            }

            var whangai_natural = '';
            if(document.getElementById('additional_whangai_natural_w').checked){
                whangai_natural = 'W';
            } else if(document.getElementById('additional_whangai_natural_n').checked){
                whangai_natural = 'N';
            } else {
                alert("Please check you are whangai or natural");
                return;
            }

            var whangai_parent = '';
            if(document.getElementById('additional_whangai_parent_w').checked){
                whangai_parent = 'W';
            } else if(document.getElementById('additional_whangai_parent_n').checked){
                whangai_parent = 'N';
            } else {
                alert("Please check parent whakapapa is Whangai or Natural");
                return;
            }

            var parent = document.getElementById('additional_parent');

            var parentGender =  document.querySelector('input[name="additional_parent_gender"]:checked').value;

            if(parent.value==='undefined' || parent.value.length===0){
                alert("Please enter the Parent's name");
                return;
            }

            var grandParent = document.getElementById('additional_grand_parent');
            var grandParentGender =  document.querySelector('input[name="additional_grand_parent_gender"]:checked').value;
            if(grandParent.value==='undefined' || grandParent.value.length===0){
                alert("Please enter the Grandparent's name");
                return;
            }
            var greatGrandParent = document.getElementById('additional_great_grand_parent');
            var greatGrandParentGender = document.querySelector('input[name="additional_great_grand_parent_gender"]:checked').value;

            var greatGreatGrandParent = document.getElementById('additional_great_great_grand_parent');
            var greatGreatGrandParentGender = document.querySelector('input[name="additional_great_great_grand_parent_gender"]:checked').value;


            var referee = document.getElementById('additional_referee');

            /**
             * Form is valid
             * @type {number}
             */
            whakapapaIndex += 1;
            if(whakapapaIndex>10){
                alert("You cannot enter anymore than 11 Whakapapa");
                return
            }

            //Load content into main table
            var row = document.getElementById('aw_'+whakapapaIndex);
            row.style.display = "";

            document.getElementById('affiliate_name_'+whakapapaIndex).value = affiliates.options[affiliates.selectedIndex].innerHTML;
            document.getElementById('marae_name_'+whakapapaIndex).value = maraes.options[maraes.selectedIndex].innerHTML;
            document.getElementById('referee_'+whakapapaIndex).value = (!referee||referee.value.length===0) ? '' : referee.value;

            document.getElementById('affiliate_id_'+whakapapaIndex).value = affiliates[affiliates.selectedIndex].value;
            console.log("Affiliate ID: ",document.getElementById('affiliate_id_'+whakapapaIndex).value);

            document.getElementById('marae_id_'+whakapapaIndex).value = maraes[maraes.selectedIndex].value;
            console.log("Marae ID: ",document.getElementById('marae_id_'+whakapapaIndex).value);

            document.getElementById('whangai_natural_'+whakapapaIndex).value = whangai_natural;
            document.getElementById('whangai_parent_'+whakapapaIndex).value = whangai_parent;
            document.getElementById('parent_'+whakapapaIndex).value = parent.value;
            document.getElementById('parent_gender_'+whakapapaIndex).value = parentGender;
            document.getElementById('grand_parent_'+whakapapaIndex).value = grandParent.value;
            document.getElementById('grand_parent_gender_'+whakapapaIndex).value = grandParentGender;
            document.getElementById('great_grand_parent_'+whakapapaIndex).value = greatGrandParent.value;
            document.getElementById('great_grand_parent_gender_'+whakapapaIndex).value = greatGrandParentGender;
            document.getElementById('great_great_grand_parent_'+whakapapaIndex).value = greatGreatGrandParent.value;
            document.getElementById('great_great_grand_parent_gender_'+whakapapaIndex).value = greatGreatGrandParentGender;
            document.getElementById('referee_'+whakapapaIndex).value = (!referee||referee.value.length===0) ? '' : referee.value;
            var refereeTitle = document.getElementById('additional_referee_title');
            document.getElementById('referee_title_'+whakapapaIndex).value = refereeTitle.options[refereeTitle.selectedIndex].innerHTML;
            document.getElementById('referee_contact_'+whakapapaIndex).value = document.getElementById('additional_referee_contact').value;

        });
    }

    let btnTamariki = document.getElementById('btnTamariki');
    if(btnTamariki){

        btnTamariki.addEventListener('click', function (e) {

            for(var idx=1; idx<20; idx++){
                let tamarikiDiv = document.getElementById('tamariki_'+idx);

                if(!tamarikiDiv){
                    alert("Limit Reached");
                    return;
                }
                if(tamarikiDiv.classList.contains('is-hidden')){
                    tamarikiDiv.classList.remove('is-hidden');
                    return;
                }
            }
        });
    }

    function isEmpty(obj) { return Object.keys(obj).length === 0; }
});
